<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  orderUnusualRegisterEdit,
  orderUnusualRegisterDetail,
} from 'api/operate';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/operate/order/deal/orderDetailTab/unusual/edit',
      formComponents: ['baseForm'],
    };
  },
  computed: {
    detailParams () {
      return {
        problemId: this.$route.query.id,
      };
    },
  },
  watch: {
    '$route.query.orderId': async function () {
      await this.$refs.baseForm.getList();
      this.getData();
    },
  },
  methods: {
    editApi: orderUnusualRegisterEdit,
    detailApi: orderUnusualRegisterDetail,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
